import React from "react";
import { OurJourney, StoryHero } from "./AboutStory";

export const OurHistory = () => {
  return (
    <>
      <StoryHero headingTag="h2" showReadMore />
      <OurJourney />
    </>
  );
};

export default OurHistory;
